module.exports = __webpack_public_path__ + "img/icon-restart.0f2a70be.svg";